<template>
  <div>
    <b-row class="d-flex justify-content-around mt-5">
      <b-col md="8" lg="6" class="text-center">
        <div class="login-outer-box text-center">
          <div class="login-inner-box text-center my-3">
            <img src="/img/logo_ape.png" id="logo_ape" alt />
            <b-overlay :show="loading" rounded="sm">
              <form id="loginForm" class="form-horizontal" accept-charset="utf-8" @submit.prevent="onSubmit()">
                <b-row class="my-2">
                  <label class="col-sm-4 control-label required"
                    >Inserisci la tua e-mail per resettare la password</label
                  >
                  <div class="col-sm-7">
                    <div class="input text">
                      <input
                        name="reference"
                        placeholder="Email"
                        class="form-control"
                        maxlength="100"
                        type="text"
                        id="reference"
                        required="required"
                        v-model="reference"
                      />
                    </div>
                  </div>
                </b-row>
                <b-row class="mt-5">
                  <b-col cols="4">
                    <input class="btn btn-primary" id="loginSubmitBtn" type="submit" value="Richiedi Reset" />
                  </b-col>
                  <b-col cols="8">
                    <b-alert :show="message != ''">{{ message }}</b-alert>
                  </b-col>
                </b-row>
              </form>
            </b-overlay>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
  name: "ResetPassword",
  data() {
    return {
      reference: "",
      loading: false,
      message: "",
    };
  },
  methods: {
    onSubmit() {
      this.loading = true;
      var self = this;
      UserService.resetPassword(this.reference)
        .then((result) => (self.message = result.data.msg), setTimeout(() => {this.$router.push("/");}, 5000))
        .catch(() => (self.message = "L'utente inserito non esiste, puoi controllare?"));

      this.loading = false;
    }, //onSubmit
  }, //methods
};
</script>
<style scoped>
.login-outer-box {
  padding: 60px 30px 40px 20px;
  background: #f49537;
  border-radius: 10px;
}
.login-inner-box {
  padding: 30px;
  background: #212025;
  border-radius: 10px;
  color: #fff;
}
#logo_ape {
  height: 100px;
  margin-top: -80px;
}
</style>
